<template>
	<div>
		<DisplayElement v-for="element in post.elements" :key="element.id" :element="element"></DisplayElement>
	</div>
</template>


<script>
	import DisplayElement from "../TextEditor/DisplayElement.vue"
	export default {
		name: "DisplayEditorPost", 
		props: {
			post: {type: Object}
		},
		components: {
			DisplayElement
		}
	}
</script>